import React from "react";
import { useUserAndGameContext } from "../../../contexts/UserAndGameContext";
import { Box, Typography, Button, useMediaQuery, useTheme } from "@mui/material";

const GameSwitchButtons = () => {
    const {
        masterPoolData,
        userData,
    } = useUserAndGameContext();
    
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const switchButtons = masterPoolData?.modalInfo?.gameSwitchButtons;

    // Function to check if user belongs to a specific pool
    const doesUserBelongToPool = (masterPoolId) => {
        // If no userData or no Games array, user is not logged in or has no games
        if (!userData || !userData.Games) {
            return false;
        }
        return userData.Games.some(game => game.masterPoolId === masterPoolId);
    };

    // If switchButtons is undefined or null, return null to prevent errors
    if (!switchButtons) {
        return null;
    }

    // Default styling values
    const defaultColor = "#002129";
    const defaultMobileFontSize = "12px";
    const defaultDesktopFontSize = "16px";
    const defaultFontWeight = 700;

    return (
        <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center',
            width: '100%',
            my: 2
        }}>
            {/* Top Text - only render if it exists */}
            {switchButtons.topText?.inGameTopText && (
                <Typography 
                    align="center" 
                    sx={{ 
                        marginBottom: '10px',
                        color: switchButtons.topText.color || defaultColor,
                        fontSize: isMobile 
                            ? switchButtons.topText.mobileFontSize || defaultMobileFontSize 
                            : switchButtons.topText.desktopFontSize || defaultDesktopFontSize,
                        fontWeight: switchButtons.topText.fontWeight || defaultFontWeight
                    }}
                >
                    {switchButtons.topText.inGameTopText}
                </Typography>
            )}

            {/* Buttons Container */}
            <Box sx={{ 
                display: 'flex', 
                flexDirection: isMobile ? 'column' : 'row',
                width: '100%',
                justifyContent: 'center',
                gap: 2,
                marginBottom: '10px',
            }}>
                {/* Render buttons if they exist */}
                {switchButtons.buttons && switchButtons.buttons.map((button, index) => {
                    // Determine which text to display based on user's game status
                    const userInGame = button.masterPoolId ? doesUserBelongToPool(button.masterPoolId) : false;
                    const buttonText = userInGame || !button.notInGameText 
                        ? button.inGameText 
                        : button.notInGameText;

                    return (
                        <Button
                            key={index}
                            variant="contained"
                            href={button.link || '#'}
                            sx={{
                                backgroundColor: button.color || theme.palette.primary.main,
                                color: '#fff',
                                '&:hover': {
                                    backgroundColor: button.color ? `${button.color}dd` : theme.palette.primary.dark,
                                },
                                width: '250px',
                                maxWidth: '250px',
                                margin: isMobile ? '0 auto' : '0',
                                fontSize: '12px',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            {buttonText}
                        </Button>
                    );
                })}
            </Box>

            {/* Bottom Text - only render if it exists */}
            {switchButtons.bottomText?.inGameBottomText && (
                <Typography 
                    align="center"
                    sx={{ 
                        color: switchButtons.bottomText.color || defaultColor,
                        fontSize: isMobile 
                            ? switchButtons.bottomText.mobileFontSize || defaultMobileFontSize 
                            : switchButtons.bottomText.desktopFontSize || defaultDesktopFontSize,
                        fontWeight: switchButtons.bottomText.fontWeight || defaultFontWeight
                    }}
                >
                    {switchButtons.bottomText.inGameBottomText}
                </Typography>
            )}
        </Box>
    );
};

export default GameSwitchButtons;